module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "weitgmefm"
    }
  }, [_c('div', {
    staticClass: "generated-style-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("Copyright © 2012")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("By Forest C. Hammond-Martin, Sr.")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "body-override",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican"), _c('br'), _vm._v("\n      are trademarks of Pelican Publishing Company, Inc.,"), _c('br'), _vm._v("\n      and are registered in the U.S. Patent and Trademark Office.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "body-spaced",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Hammond-Martin, Forest C.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("With Edwards in the Governor’s mansion : from Angola to free man / by Forest C. Hammond-Martin, Sr. ; edited by Tom Aswell.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("p. cm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("ISBN 978-1-4556-1625-1 (hbk : alk. paper) — ISBN 978-1-4556-1626-8 (e-book) 1. Hammond-Martin, Forest C. 2. Edwards, Edwin W. 3. Ex-convicts—Louisiana—Baton Rouge—Biography. 4. African American prisoners—Louisiana—Baton Rouge—Biography. 5. Criminal justice, Administration of—Corrupt practices—Louisiana—Baton Rouge. 6. Convict labor—Louisiana—Baton Rouge. 7. Governors—Louisiana—Conduct of life. 8. Political corruption—Louisiana—Baton Rouge. I. Aswell, Tom. II. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("HV9468.H225A3 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("976.3’063092—dc23")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("[B]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "pushed"
  }, [_vm._v("2012006975")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "ACIDCREA.EPS",
      "src": "Images/ACIDCREA_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("Published by Pelican Publishing Company, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9176db8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Copyright.vue
// module id = 66
// module chunks = 0